String.prototype.format = function format(...args) {
	return this.replace(/{([0-9]+)}/g, (match, index) => (typeof args[index] === 'undefined' ? match : args[index])); // Check if the argument is there
};